module.exports = __webpack_public_path__ + "img/role-kaka.842cf7d2.png";